import clsx from 'clsx';
import { useOwnTranslate } from 'lib/hooks/useOwnTranslate';
import { Dispatch, SetStateAction } from 'react';

type Props = {
  timeInterval: number;
  setTimeInterval: Dispatch<SetStateAction<number>>;
};

const timeIntervalValues = [6, 12, 36];

const HousePricesTrendsTimeInterval = ({
  timeInterval,
  setTimeInterval,
}: Props) => {
  const { t } = useOwnTranslate('global');
  const timeIntervalData = timeIntervalValues.map((ti) => ({
    value: ti,
    year: Math.floor(ti / 12),
    month: ti % 12,
    yearPhrase: 'year',
    monthPhrase: 'month',
  }));

  return (
    <>
      <div className="max-w-[1000px] w-full overflow-x-scroll custom-scrollbar pb-1">
        <div className="flex flex-row items-center justify-start gap-2">
          {timeIntervalData.map((time) => (
            <button
              key={time.value}
              className={clsx(
                'btn btn-sm shadow-none transition-all duration-200 whitespace-nowrap',
                { 'btn-grey': timeInterval != time.value },
                { 'btn-primary-light': timeInterval == time.value }
              )}
              onClick={() => setTimeInterval(time.value)}
            >
              {`${time.year > 0
                ? time.year.toString().concat(' ').concat(t(time.yearPhrase))
                : ''
                } ${time.month > 0
                  ? time.month
                    .toString()
                    .concat(' ')
                    .concat(t(time.monthPhrase))
                  : ''
                }`}
            </button>
          ))}
        </div>
      </div>
    </>
  );
};

export default HousePricesTrendsTimeInterval;
